import { formatTimezoneDateString, formatTimezoneDateStringDistance } from "@cp/toolkit";
import { cn } from "../utils";
import { Tooltip, TooltipContent, TooltipTrigger } from "./tooltip";

export const RelativeDate = ({ date, className }: { date: string | null; className?: string }) => {
  if (!date) {
    return null;
  }

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className={cn("inline-flex", className)}>{formatTimezoneDateStringDistance(date)} ago</span>
      </TooltipTrigger>
      <TooltipContent className="text-2xs">{formatTimezoneDateString(date, "MMMM d, yyyy, h:mm aa")}</TooltipContent>
    </Tooltip>
  );
};
